/**
 * @abstract
 * @memberOf woosmap.layers
 * @since 1.2.0
 */
class BaseLayer {
    /**
     * BaseLayer.
     * @param {Object} options
     * @constructor
     */
    constructor(options) {
        this._options = options || {};
        if (this._options.renderer) this._renderer = this._options.renderer;
        else {
            this._renderer = this._default_renderer({
                eventListeners: this._options.eventListeners,
                styler: this._options.styler,
            });
        }

        this._storeEventManager = this._options.eventManager;

        if (this._storeEventManager) {
            this._renderer.setStoreEventManager(this._storeEventManager);
        }

        this._map = null;
    }

    /**
     * Should be implemented to define the default renderer
     * @param {Object} options
     * @abstract
     * @private
     */
    _default_renderer(options) {
        // jshint ignore:line
    }

    /**
     * Set the map instance
     * @param {google.maps.Map} map
     */
    setMap(map) {
        this._map = map;
        this._renderer.setMap(map);
    }

    /**
     * Getter to access to the map instance
     * @returns {google.maps.Map}
     */
    getMap() {
        return this._map;
    }

    /**
     * Set the visibility of the data
     * @param {Boolean} isHidden
     */
    setHidden(isHidden) {
        if (this.getHidden() !== isHidden) {
            const map = isHidden ? null : this._map;
            this._renderer.setMap(map);
        }
    }

    /**
     * Getter to access to the visibility state
     * @returns {Boolean}
     */
    getHidden() {
        return this._renderer.getMap() === null;
    }

    clear() {
        this._renderer.clear();
    }

    getDataBounds() {
        return this._renderer.getDataBounds();
    }

    /**
     * Set the map instance
     * @param {Store} selectedStore the store to select.
     */
    selectStore(selectedStore) {
        this._renderer.selectStore(selectedStore);
    }
}

module.exports = BaseLayer;
